import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';
import { FormattedDate } from '@dbk/format';
import Text, {XSmall} from '../text';
import omit from 'lodash/omit';
import { NO_DATA } from '../../../constants';
import { injectIntl } from 'react-intl';

const FullMonthYear = props => {
  if (props.value && typeof props.value === 'string') {
    return (
      props.onlySmallMonth ?
        <FormattedDate
          month="short"
          value={new Date(props.value)}
          {...omit(props, 'value', 'renderProps')}
        >{(txt) => <XSmall style={{color: props.color}} {...props.renderProps}> {txt.toUpperCase()}</XSmall>}
        </FormattedDate>
      :
      <FormattedDate
        month="long"
        year="numeric"
        value={new Date(props.value)}
        {...omit(props, 'value', 'renderProps')}
      >{(txt) => <Text {...props.renderProps}> {txt}</Text>}
      </FormattedDate>
    );
  }
  return (
    <div aria-label={props.intl.messages['app.common.nullValue']}>
      <Text {...props.renderProps}> {NO_DATA}</Text>
    </div>
    )
};

FullMonthYear.propTypes = {
  ...FormattedDate.PropTypes,
  value: PropTypes.any,
};

FullMonthYear.contextTypes = {
  intl: PropTypes.object,
};

export default pure(injectIntl(FullMonthYear));
